import { Card, Tag, message } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { createManagementResourceRequest, listManagementResourceRequest } from "../../api/management";
import ProgressLoader from "../../components/Loader/ProgressLoader";
import Filterbox from "../../ui/FilterBox/Filterbox";
import DataTable from "../../ui/DataTable/DataTable";
import SapaHeader from "../../ui/Header/Header";

const Administrators = () => {
  const [admins, setAdmins] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchAdmins = useCallback(async (filters = {}) => {
    setIsLoading(true);
    try {
      const response = await listManagementResourceRequest("admins", filters);
      setAdmins(response?.data?.data?.data || []);
    } catch (error) {
      message.error(error?.response?.data?.message || "Unable to fetch administrators.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handleCreateAdmin = async (values) => {
    await createManagementResourceRequest("admins", values);
    message.success("Administrator created successfully.");
    fetchAdmins();
  };

  useEffect(() => {
    fetchAdmins();
  }, [fetchAdmins]);

  const columns = [
    {
      title: "Name",
      key: "name",
      render: (_, record) => [record.first_name, record.last_name].filter(Boolean).join(" ") || "Not provided",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone_number",
      key: "phone_number",
      render: (phoneNumber) => phoneNumber || "Not provided",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (role) => <Tag color="blue">{role || "admin"}</Tag>,
    },
    {
      title: "Created",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => (date ? new Date(date).toLocaleString() : "Not available"),
    },
  ];

  return (
    <ProgressLoader isLoading={isLoading}>
      <div className="Administrators">
        <SapaHeader page={"Administrators"} />
        <Card className="sapa-administrators__container">
          <Filterbox
            displayFilter={"none"}
            showAdmin={true}
            searchAction={fetchAdmins}
            searchIsLoading={isLoading}
            onCreateAdmin={handleCreateAdmin}
            dataToExport={admins}
            exportFileName="administrators.csv"
          />
          <DataTable
            dataSource={admins}
            columns={columns}
            scrollX={860}
          />
        </Card>
      </div>
    </ProgressLoader>
  );
};

export default Administrators;
